import {DatePicker, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Controller, useFormContext} from "react-hook-form";
import {LiveEventEventTypeFormFieldsType} from "../../../types";
import {StyledInputValue} from "../../../../../../live-classes/live-classes-form/live-classes-form.style";
import moment from "moment";
import type {RangePickerProps} from "antd/es/date-picker";
import {LiveEventEventTypeTopicTypeSingleEventFormFieldProps} from "../types";

export const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days before today and today
  return current && current < moment().endOf("day");
};

export function LiveEventEventTypeTopicTypeSingleEventStartDateFormField({
  formType,
}: {
  formType: LiveEventEventTypeTopicTypeSingleEventFormFieldProps["formType"];
}) {
  const {control, getValues} = useFormContext<LiveEventEventTypeFormFieldsType>();
  const defaultValue = getValues("startDate");
  const hasDefaultValue = formType === "edit";
  return (
    <div>
      <FormField
        id={"singleEventStartDate"}
        label={"Event date"}
        renderInput={(id) =>
          hasDefaultValue ? (
            <StyledInputValue>
              <p>{defaultValue}</p>
            </StyledInputValue>
          ) : (
            <Controller
              control={control}
              name="startDate"
              render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
                <Space size={16} direction="vertical" style={{display: "flex"}}>
                  <DatePicker
                    disabledDate={disabledDate}
                    size="large"
                    style={{width: "100%"}}
                    onChange={(date, dateString) => onChange(dateString)}
                    status={error?.message ? "error" : undefined}
                    value={!value ? undefined : moment(value)}
                    onBlur={onBlur}
                    ref={ref}
                  />
                  <FormFieldError errorMessage={error?.message} />
                </Space>
              )}
            />
          )
        }
      />
    </div>
  );
}
